import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import { SxProps, Theme, styled } from '@mui/material/styles'
import { ReactNode } from 'react'

const ModalBody = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: 'white',
  padding: theme.spacing(2),
  borderRadius: '4px',
}))

type ModalProps = {
  open: boolean
  children: ReactNode
  width?: string | number
  maxWidth?: string | number
  sx?: SxProps<Theme>
}

function StyledModal(props: ModalProps): React.ReactElement {
  const { open, width, maxWidth, sx } = props

  return (
    <Modal open={open}>
      <ModalBody sx={{ width, maxWidth, ...sx }}>{props.children}</ModalBody>
    </Modal>
  )
}

export default StyledModal
